// Exporting it in module.js way since it is being used in node process
module.exports = {
  networkTimeoutThreshold: "process.env.NETWORK_TIMEOUT" || 40000,
  url: "process.env.url" || "https://webapp.fibe.in/",
  cmsUrl: "process.env.CMS_ENDPOINT" || "https://altcont.fibe.in",
  bucket: "process.env.bucket" || "esdoc",
};
